import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ArrowLeftRight, ChevronDown } from "lucide-react";
import { handleGetAppLogo } from "../../../utils/constants/GlobalAppAndLanguage";
import useGlobalAppAndLanguage from "../../../hooks/useGlobalAppAndLanguage";
import AppSwitchModal from "./AppSwitchModal";

/** Navbar button with the selected app and language; opens the switch modal. `compact` shows the logo only. */
const AppSwitcher = ({ compact = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { globalApp, appLabel, languageLabel, globalLabel } =
    useGlobalAppAndLanguage();

  return (
    <>
      <button
        type="button"
        title={`Switch app · now ${globalLabel}`}
        onClick={() => setIsOpen(true)}
        className={
          compact
            ? "flex items-center gap-1.5 rounded-xl bg-white/10 p-1 pr-2 transition-colors hover:bg-white/20"
            : "group flex h-9 items-center gap-2.5 rounded-lg px-2 text-left transition-colors hover:bg-white/60"
        }
      >
        <img
          src={handleGetAppLogo({ app: globalApp })}
          alt=""
          className="w-7 shrink-0 rounded-md bg-white object-cover ring-1 ring-black/5"
        />
        {!compact && (
          <span className="min-w-0 leading-tight">
            <span className="block truncate text-[12px] font-semibold text-[#2b2560]">
              {appLabel}
            </span>
            <span className="block truncate text-[11px] text-[#6f6aa8]">
              {languageLabel}
            </span>
          </span>
        )}
        {compact ? (
          <ArrowLeftRight className="h-3.5 w-3.5 shrink-0 text-white/80" />
        ) : (
          <ChevronDown className="h-3.5 w-3.5 shrink-0 text-[#6f6aa8] transition-transform group-hover:translate-y-px" />
        )}
      </button>
      {isOpen &&
        createPortal(
          <AppSwitchModal open={isOpen} onClose={() => setIsOpen(false)} />,
          document.body
        )}
    </>
  );
};

export default AppSwitcher;
